exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-common-filter-footer .ba-common-button.is-variant_normal{min-width:80px}", ""]);

// exports
